import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import { SnapElemnt } from '../manager/SnapManager';

export default class ItemControllerWallObject {
    target: marietta.webcad.item.WallObject;

    cornerPickerList: marietta.webcad.control.parts.RoomCornerDragger[];

    movePickerList: marietta.webcad.control.parts.RoomMovePickerWall[];

    startPoint: marietta.core.Point;

    startP1: marietta.core.Point;

    startP2: marietta.core.Point;

    x: number;

    y: number;

    width: number;

    height: number;

    prevPoint: marietta.core.Point;

    currentWall: any;

    public spt: SVGSprite;

    public emptySpt: SVGSprite;

    snapList: SnapElemnt[];

    initSnap: boolean = false;

    moveAmountX: number;

    moveAmountY: number;

    startCoordinatesWall: marietta.webcad.collection.PointCollection[];

    selectedPicker:marietta.webcad.control.parts.RoomCornerDragger= null;

    /**
     * コンストラクタ
     * @param _target
     */
    constructor(_target: marietta.webcad.item.WallObject) {
      this.target = _target; // ターゲット

      // 形状の生成
      const viewObj: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      viewObj.id = 'controller';
      this.spt = new SVGSprite(viewObj);

      // ビューの初期化
      this.initMe();
      if (this.target.itemInfo.lock) {
        this.hideToolTips();
      } else {
        // this.showToolTips();
      }
    }

    /**
     * 初期化
     */
    initMe() {
      const tarLayer: marietta.webcad.layer.FloorShitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.target.itemInfo.floor, true) as marietta.webcad.layer.FloorShitaeLayer;

      this.cornerPickerList = [];
      this.movePickerList = [];
      this.selectedPicker = null;

      // 既存のスナップガイドを削除
      if (document.querySelector('#controller_snap_guide'))document.querySelector('#controller_snap_guide').remove();
      marietta.webcad.WebCADGlobal.snapManager.hideAll();

      // コントローラー追加
      let corner: marietta.webcad.control.parts.RoomCornerDragger;
      const wallPicker: marietta.webcad.control.parts.RoomMovePickerWall = new marietta.webcad.control.parts.RoomMovePickerWall(this.spt, 1);
      wallPicker.moveFunc = this.onMoveWallDragger;
      wallPicker.moveEndFunc = this.onMoveEndWallDragger;
      // 部屋がない壁を選択しているのでまっすぐ壁設定メニューを出す
      const { dotList } = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo;
      // document.getElementById('itemControlPanel').classList.add('removeAndSettingsButton');
      // document.getElementById('btnWallSetting').style.display = 'block';
      const point = [tarLayer.spt.localToGlobal(dotList[0].point), tarLayer.spt.localToGlobal(dotList[1].point)];
      wallPicker.firstDot = new marietta.core.Point(point[0].x, point[0].y);
      wallPicker.onMouseDownMe(marietta.core.Point.interpolate(new marietta.core.Point(point[0].x, point[0].y), new marietta.core.Point(point[1].x, point[1].y), 0.5));
      this.movePickerList.push(wallPicker);

      for (let i: number = 1; i <= this.target.itemInfo.dotList.length; i += 1) {
        corner = new marietta.webcad.control.parts.RoomCornerDragger(this.spt, i);
        corner.moveFunc = this.onMoveCornerDragger;
        corner.moveEndFunc = this.onMoveEndCornerDragger;
        this.cornerPickerList.push(corner);
      }
      this.selectedPicker = this.cornerPickerList[0];
      this.selectedPicker.viewObj.setAttribute("fill", "#eb5e00");
      this.selectedPicker.viewObj.setAttribute("stroke", "#eb5e00");

      // 作成する階
      tarLayer.spt.addChild(this.spt);

      marietta.webcad.WebCADGlobal.snapManager.createSnapGuide(tarLayer); // スナップガイドを作成

      // コントローラーの位置調整
      this.setArrowPositions();

      // ターゲットに合わせてサイズ変更
      this.resizeToTarget();
    }

    /**
     * ターゲットに合わせて各種パーツリサイズ
     */
    resizeToTarget() {
      // 位置合わせ
      this.syncMeToTarget();
    }

    /**
     * ターゲットにシンクロする
     * アイテムのドラッグ時に呼び出される
     */
    syncMeToTarget() {
      this.x = this.target.itemInfo.x;
      this.y = this.target.itemInfo.y;
      this.spt.x = this.x;
      this.spt.y = this.y;
      this.spt.update();
    }

    /**
     * ピッカーのサイズ更新
     */
    public updatePickers(): void {
      for (let i: number = 0; i < this.cornerPickerList.length; i += 1) {
        (this.cornerPickerList[i] as marietta.webcad.control.parts.RoomCornerDragger).updateTranslate();
      }
    }

    /**
     * コントロールピッカーが移動された
     */
    onMoveCornerDragger = (e: MouseEvent, target: marietta.webcad.control.parts.RoomCornerDragger) => {
      // ロックされている場合は、行わない
      if (!this.target.isCapableOfResize()) return;
      for (let i = 0; i < this.target.wallGuideList.length; i += 1) {
        this.target.wallGuideList[i].removeTextBoxObj();
      }
      // 開始時のアイテム場所保持
      if (!this.startPoint) {
        this.currentWall = target;
        this.initSnap = true;
        if (!this.emptySpt) {
          /*
            本来はtarget.sptのmouseX/mouseYで取得できるが、
            拡縮するとアイテムの位置が変わるため、正しいドラッグ位置が取れなくなる。
            そのためタグを持たないemptySptを別途作って、mouseX/mouseYの値を
            取得している。
          */
          this.emptySpt = new SVGSprite(null, true);
          this.emptySpt.setEmptyParam(this.target.spt);
          this.target.spt.parent.addChild(this.emptySpt);
        }

        this.startPoint = new marietta.core.Point(
          this.emptySpt.mouseX * this.target.spt.scaleX,
          this.emptySpt.mouseY * this.target.spt.scaleY,
        );
      }

      // add horizontal and vertical snap for target
      if (this.initSnap) {
        this.initSnap = false;
        this.snapList = [];
        this.snapList = marietta.webcad.WebCADGlobal.snapManager.snapElements.map((m: SnapElemnt) => m);
      }

      let newPoint: marietta.core.Point = new marietta.core.Point(this.emptySpt.x + this.emptySpt.mouseX * this.target.spt.scaleX, this.emptySpt.y + this.emptySpt.mouseY * this.target.spt.scaleY);
      let previousPoint = null;
      if (this.target.itemInfo.dotList != null && this.target.itemInfo.dotList.length) {
        if (this.currentWall.index === this.cornerPickerList.length) {
          previousPoint = this.target.itemInfo.dotList[this.currentWall.index - 2];
        } else {
          previousPoint = this.target.itemInfo.dotList[this.currentWall.index];
        }
        // 入力を垂直・水平・90度化する処理
        if (e.shiftKey && previousPoint) {
          const point1: marietta.core.Point = new marietta.core.Point(previousPoint.x, newPoint.y);
          const point2: marietta.core.Point = new marietta.core.Point(newPoint.x, previousPoint.y);
          const convertPoint: marietta.core.Point = new marietta.core.Point(newPoint.x, newPoint.y);
          const distance1: number = marietta.core.Point.distance(convertPoint, point1);
          const distance2: number = marietta.core.Point.distance(convertPoint, point2);
          // 前の点からマウスカーソルへの角度を計算して絶対値に変換する。
          if (distance1 < distance2) { // 垂直
            newPoint = new marietta.core.Point(previousPoint.x, newPoint.y);
          } else { // 水平
            newPoint = new marietta.core.Point(newPoint.x, previousPoint.y);
          }
        }
      }
      // アイテムの角度分、座標変換を行う
      const r: number = (-(this.target.spt.rotation % 360) / 180) * Math.PI;
      const xx: number = newPoint.x * Math.cos(r) - newPoint.y * Math.sin(r);
      const yy: number = newPoint.x * Math.sin(r) + newPoint.y * Math.cos(r);
      newPoint.x = xx;
      newPoint.y = yy;

      // オブジェクト吸着が拘束する軸はそのまま、残りの軸をグリッドへ吸着させる
      const snap = this.getSnapPosition(newPoint);
      const snapPosition: marietta.core.Point = marietta.webcad.util.WebCADUtil
        .snapPointToGrid(snap.point, snap.lockX, snap.lockY);
      target.move(snapPosition.x - this.emptySpt.x, snapPosition.y - this.emptySpt.y);

      // 部屋を同期させる
      this.setWallToMe();
    }

    /**
     * コントロールピッカーのドラッグ終了
     */
    onMoveEndCornerDragger = () => {
      this.startPoint = null;
      this.currentWall = null;

      if (this.emptySpt && this.emptySpt.parent) {
        this.emptySpt.parent.removeChild(this.emptySpt);
        this.emptySpt = null;
      }
      if (this.target) {
        this.target.showHideWallGuide(true);
      }
      if (document.querySelector('.dummy_wall_input')) document.querySelector('.dummy_wall_input').remove();
      for (let i = 0; i < this.target.wallGuideList.length; i += 1) {
        this.target.wallGuideList[i].showWallInput();
      }
      marietta.webcad.WebCADGlobal.snapManager.hideAll();
      marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
    }

    /**
   * コントロールピッカーが移動された
   */
    onMoveWallDragger = (e: MouseEvent, target: marietta.webcad.control.parts.RoomMovePickerWall) => {
      // ロックされている場合は、行わない
      if (!this.target.isCapableOfResize()) return;

      // カレント
      this.currentWall = target;

      // 前後のドット
      const parnerDotList = [];
      // 前のドット
      if (this.currentWall.index === this.cornerPickerList.length) {
        parnerDotList.push(this.cornerPickerList[this.cornerPickerList.length - 1]);
      } else {
        parnerDotList.push(this.cornerPickerList[this.currentWall.index - 1]);
      }
      // 次のドット
      if (this.currentWall.index === this.cornerPickerList.length) {
        parnerDotList.push(this.cornerPickerList[0]);
      } else {
        parnerDotList.push(this.cornerPickerList[this.currentWall.index]);
      }

      // ピッカーのXYのいずれかが共通していたら、コーナーのスナップ方式と同等にする。そうでなければ従来の方式にする
      let newPoint: marietta.core.Point;
      let r: number;
      let xx: number;
      let yy: number;
      let snapPosition: marietta.core.Point;

      if (parnerDotList[0].x === parnerDotList[1].x || parnerDotList[0].y === parnerDotList[1].y) {
        // 開始時のアイテム場所保持
        if (this.startPoint === undefined || this.startPoint === null) {
          this.initSnap = true;
          if (this.emptySpt === undefined || this.emptySpt === null) {
            this.emptySpt = new SVGSprite(null, true);
            this.emptySpt.setEmptyParam(this.target.spt);
            this.target.spt.parent.addChild(this.emptySpt);
          }
          this.startPoint = new marietta.core.Point(
            this.emptySpt.mouseX * this.target.spt.scaleX,
            this.emptySpt.mouseY * this.target.spt.scaleY,
          );
          // 開始時の座標
          this.startCoordinatesWall = this.target.itemInfo.dotList.concat();
        }
        if (this.initSnap) {
          this.initSnap = false;
          this.snapList = [];
          this.snapList = marietta.webcad.WebCADGlobal.snapManager.snapElements.map((m: SnapElemnt) => m);
        }
        newPoint = new marietta.core.Point(
          this.emptySpt.x + this.emptySpt.mouseX * this.target.spt.scaleX,
          this.emptySpt.y + this.emptySpt.mouseY * this.target.spt.scaleY,
        );
        // アイテムの角度分、座標変換を行う
        r = (-(this.target.spt.rotation % 360) / 180) * Math.PI;
        xx = newPoint.x * Math.cos(r) - newPoint.y * Math.sin(r);
        yy = newPoint.x * Math.sin(r) + newPoint.y * Math.cos(r);
        newPoint.x = xx;
        newPoint.y = yy;

        // オブジェクト吸着が拘束する軸はそのまま、残りの軸をグリッドへ吸着させる
        const wallSnap = this.getSnapPosition(newPoint);
        snapPosition = marietta.webcad.util.WebCADUtil
          .snapPointToGrid(wallSnap.point, wallSnap.lockX, wallSnap.lockY);
        if (parnerDotList[0].x === parnerDotList[1].x) {
          target.moveX(snapPosition.x - this.emptySpt.x);
          parnerDotList[0].moveX(snapPosition.x - this.emptySpt.x);
          parnerDotList[1].moveX(snapPosition.x - this.emptySpt.x);
        } else {
          target.moveY(snapPosition.y - this.emptySpt.y);
          parnerDotList[0].moveY(snapPosition.y - this.emptySpt.y);
          parnerDotList[1].moveY(snapPosition.y - this.emptySpt.y);
        }
        // 部屋を同期させる
        this.setWallToMe();

        this.startPoint = null;
        this.currentWall = null;

        if (this.emptySpt && this.emptySpt.parent) {
          this.emptySpt.parent.removeChild(this.emptySpt);
          this.emptySpt = null;
        }
      }
      //----------------------------------------------------

      if (this.currentWall === null || this.currentWall === undefined) return;

      // 開始時のアイテム場所保持
      if (!this.startP1 || !this.startP2) {
        this.initSnap = true;
        if (this.emptySpt === undefined || this.emptySpt === null) {
          /*
            本来はtarget.sptのmouseX/mouseYで取得できるが、
            拡縮するとアイテムの位置が変わるため、正しいドラッグ位置が取れなくなる。
            そのためタグを持たないemptySptを別途作って、mouseX/mouseYの値を
            取得している。
          */
          this.emptySpt = new SVGSprite(null, true);
          this.emptySpt.setEmptyParam(this.target.spt);
          this.target.spt.parent.addChild(this.emptySpt);
        }

        this.startPoint = new marietta.core.Point(
          this.emptySpt.mouseX * this.target.spt.scaleX,
          this.emptySpt.mouseY * this.target.spt.scaleY,
        );

        this.startP1 = new marietta.core.Point(parnerDotList[0].x, parnerDotList[0].y);
        this.startP2 = new marietta.core.Point(parnerDotList[1].x, parnerDotList[1].y);

        // 開始時の座標
        this.startCoordinatesWall = this.target.itemInfo.dotList.concat();
      }

      if (this.initSnap) {
        this.initSnap = false;
        this.snapList = [];
        this.snapList = marietta.webcad.WebCADGlobal.snapManager.snapElements.map((m: SnapElemnt) => m);
      }

      newPoint = new marietta.core.Point(
        this.emptySpt.mouseX * this.target.spt.scaleX,
        this.emptySpt.mouseY * this.target.spt.scaleY,
      );

      // アイテムの角度分、座標変換を行う
      r = (-(this.target.spt.rotation % 360) / 180) * Math.PI;
      xx = newPoint.x * Math.cos(r) - newPoint.y * Math.sin(r);
      yy = newPoint.x * Math.sin(r) + newPoint.y * Math.cos(r);
      newPoint.x = xx;
      newPoint.y = yy;
      // 移動距離
      // let snap_unit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
      let tempMoveAmountX: number = (newPoint.x - this.startPoint.x);
      let tempMoveAmountY: number = (newPoint.y - this.startPoint.y);

      const p1 = new marietta.core.Point(this.startP1.x + tempMoveAmountX, this.startP1.y + tempMoveAmountY);
      const p2 = new marietta.core.Point(this.startP2.x + tempMoveAmountX, this.startP2.y + tempMoveAmountY);
      const snap1 = this.getSnapPosition(p1);
      const snap2 = this.getSnapPosition(p2);
      if (snap1 && snap1.snaped) {
        if (snap2.snaped && snap2.distance < snap1.distance) {
          tempMoveAmountX = (snap2.point.x - this.startP2.x);
          tempMoveAmountY = (snap2.point.y - this.startP2.y);
        } else {
          tempMoveAmountX = (snap1.point.x - this.startP1.x);
          tempMoveAmountY = (snap1.point.y - this.startP1.y);
        }
      }
      if (snap2 && snap2.snaped) {
        if (snap1.snaped && snap1.distance < snap2.distance) {
          tempMoveAmountX = (snap1.point.x - this.startP1.x);
          tempMoveAmountY = (snap1.point.y - this.startP1.y);
        } else {
          tempMoveAmountX = (snap2.point.x - this.startP2.x);
          tempMoveAmountY = (snap2.point.y - this.startP2.y);
        }
      }

      this.moveAmountX = tempMoveAmountX;
      this.moveAmountY = tempMoveAmountY;

      // 壁を同期させる
      this.resizeWallToMe();
    }

    /**
    * 壁の大きさをあわせる
    * */
    resizeWallToMe(force: boolean = false) {
      if (force) this.prevPoint = null;

      // 前回と同じ位置なら、行わない
      if (this.prevPoint != null && (this.prevPoint.x === this.emptySpt.mouseX && this.prevPoint.y === this.emptySpt.mouseY)) return;
      this.prevPoint = new marietta.core.Point(this.emptySpt.mouseX, this.emptySpt.mouseY);

      // ドラッグしている辺に影響する頂点の座標を変更する
      const { index } = this.currentWall as marietta.webcad.control.parts.RoomMovePickerWall;
      const p1: number = index - 1;
      let p2: number = (index === this.movePickerList.length) ? 0 : index;

      // ドラッグ開始時の頂点をコピー
      const newCoordinates: marietta.webcad.collection.PointCollection[] = [];
      const info: marietta.webcad.collection.PointCollection[] = this.startCoordinatesWall;
      if (this.movePickerList.length > 1) {
        for (let i: number = 0; i < this.movePickerList.length; i += 1) {
          newCoordinates.push(new marietta.webcad.collection.PointCollection(info[i].x, info[i].y, info[i].wall_type));
        }
      } else {
        for (let i: number = 0; i < info.length; i += 1) {
          newCoordinates.push(new marietta.webcad.collection.PointCollection(info[i].x, info[i].y, info[i].wall_type));
        }
        p2 = (index === info.length) ? 0 : index;
      }

      // 方向を特定する
      let vertical: Boolean = false;
      if ((this.currentWall as marietta.webcad.control.parts.RoomMovePickerWall).rotation === 90 || (this.currentWall as marietta.webcad.control.parts.RoomMovePickerWall).rotation === -90) {
        vertical = true;
      }
      // 方向を特定する
      if ((this.currentWall as marietta.webcad.control.parts.RoomMovePickerWall).rotation % 90 === 0 || (this.currentWall as marietta.webcad.control.parts.RoomMovePickerWall).rotation === 0) {
        if ((this.currentWall as marietta.webcad.control.parts.RoomMovePickerWall).rotation === 90 || (this.currentWall as marietta.webcad.control.parts.RoomMovePickerWall).rotation === -90) {
          vertical = true;
        }
        // 頂点を変更する
        newCoordinates[p1].x += vertical ? 0 : this.moveAmountX;
        newCoordinates[p1].y += vertical ? this.moveAmountY : 0;
        newCoordinates[p2].x += vertical ? 0 : this.moveAmountX;
        newCoordinates[p2].y += vertical ? this.moveAmountY : 0;
      } else {
        // 頂点を変更する
        newCoordinates[p1].x += this.moveAmountX;
        newCoordinates[p1].y += this.moveAmountY;
        newCoordinates[p2].x += this.moveAmountX;
        newCoordinates[p2].y += this.moveAmountY;
      }
      this.target.itemInfo.dotList = newCoordinates;
      this.target.reCreateImage();

      //見積リスト更新
      marietta.webcad.WebCADGlobal.quotationItemList.createData();

      // 関連するシンボルの位置移動
      this.setArrowPositions();
    }

    /**
    * コントロールピッカーのドラッグ終了
    */
    onMoveEndWallDragger = () => {
      this.startPoint = null;
      this.startP1 = null;
      this.startP2 = null;
      this.startCoordinatesWall = null;
      this.currentWall = null;
      this.prevPoint = null;

      if (this.emptySpt && this.emptySpt.parent) {
        this.emptySpt.parent.removeChild(this.emptySpt);
        this.emptySpt = null;
      }
      if (this.target) {
        this.target.showHideWallGuide(true);
      }
      if (document.querySelector('.dummy_wall_input')) document.querySelector('.dummy_wall_input').remove();
      for (let i = 0; i < this.target.wallGuideList.length; i += 1) {
        this.target.wallGuideList[i].showWallInput();
      }
      marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
      marietta.webcad.WebCADGlobal.snapManager.hideAll();
    }

    /**
     * スナップ
     * @param p
     * @returns
     */
    getSnapPosition(p: marietta.core.Point) {
      let snap = null;
      let snaped = false;
      // 吸着要素が拘束する軸。拘束されない軸は呼び出し側でグリッドに吸着させる
      let lockX = false;
      let lockY = false;
      const snapPoint: marietta.core.Point = p.clone();
      marietta.webcad.WebCADGlobal.snapManager.hideAll();
      snap = marietta.webcad.WebCADGlobal.snapManager.nearestSnap(this.snapList, snapPoint.x, snapPoint.y);
      if (snap) {
        snapPoint.x = snap.point.x;
        snapPoint.y = snap.point.y;
        snaped = true;
        ({ x: lockX, y: lockY } = marietta.webcad.manager.SnapManager.getConstrainedAxes(snap.snap));
      }
      return {
        point: snapPoint, snaped, distance: snap ? snap.point.distance : 0, lockX, lockY,
      };
    }

    /**
     * 壁の大きさを変える
     * */
    setWallToMe(force: Boolean = false) {
      if (force) this.prevPoint = null;

      // 前回と同じ位置なら、行わない
      if (this.prevPoint != null && (this.prevPoint.x === this.emptySpt.mouseX && this.prevPoint.y === this.emptySpt.mouseY)) return;
      this.prevPoint = new marietta.core.Point(this.emptySpt.mouseX, this.emptySpt.mouseY);

      // 部屋アイテムに更新
      this.target.itemInfo.dotList = this.currentCoordinates;
      this.target.reCreateImage();
      // 関連するシンボルの位置移動
      this.setArrowPositions();
    }

    /**
     * 現在の座標を取得
     * */
    get currentCoordinates(): marietta.webcad.collection.PointCollection[] {
      const points: number = this.cornerPickerList.length;
      const myCoordinates: marietta.webcad.collection.PointCollection[] = [];
      let tarSymbol: marietta.webcad.control.parts.RoomCornerDragger;
      let info: marietta.webcad.collection.PointCollection;

      for (let i: number = 0; i < points; i += 1) {
        tarSymbol = this.cornerPickerList[i] as marietta.webcad.control.parts.RoomCornerDragger;
        info = this.target.itemInfo.dotList[i];
        myCoordinates.push(new marietta.webcad.collection.PointCollection(tarSymbol.x, tarSymbol.y, info.wall_type));
      }
      return myCoordinates;
    }

    /**
    * 矢印位置を合わせる
    * */
    setArrowPositions() {
      // 頂点作成
      const points: number = this.target.itemInfo.dotList.length;
      let cornerPicker: marietta.webcad.control.parts.RoomCornerDragger;
      let movePicker: marietta.webcad.control.parts.RoomMovePickerWall;
      let i: number;
      let point1: marietta.core.Point;
      let point2: marietta.core.Point;
      let angle: number;
      let pRadian: number;
      for (i = 0; i < this.movePickerList.length; i += 1) {
        movePicker = this.movePickerList[i];
        movePicker.firstDot = this.target.itemInfo.dotList[i].point;
        movePicker.movePickerLength = this.movePickerList.length;
        if (i === this.target.itemInfo.dotList.length - 1) {
          movePicker.secondDot = this.target.itemInfo.dotList[0].point;
        } else {
          movePicker.secondDot = this.target.itemInfo.dotList[i + 1].point;
        }
        point1 = new marietta.core.Point(this.target.itemInfo.dotList[i].x, this.target.itemInfo.dotList[i].y);
        point2 = (i === points - 1) ? new marietta.core.Point(this.target.itemInfo.dotList[0].x, this.target.itemInfo.dotList[0].y) : new marietta.core.Point(this.target.itemInfo.dotList[i + 1].x, this.target.itemInfo.dotList[i + 1].y);
        // 角度
        pRadian = Math.atan2((point1.x - point2.x), (point1.y - point2.y));
        angle = pRadian / (Math.PI / 180);
        movePicker.rotate(-angle);
      }
      for (i = 0; i < this.cornerPickerList.length; i += 1) {
        cornerPicker = this.cornerPickerList[i];
        cornerPicker.move(this.target.itemInfo.dotList[i].x, this.target.itemInfo.dotList[i].y);
      }
    }

    /**
     * Translateのアップデート
     */
    updateTransforms() {
      this.spt.x = this.x;
      this.spt.y = this.y;
      this.spt.update();
    }

    hideToolTips() {
      for (let i: number = 0; i < this.cornerPickerList.length; i += 1) {
        (this.cornerPickerList[i] as marietta.webcad.control.parts.RoomCornerDragger).disableDragger();
      }

      for (let i: number = 0; i < this.movePickerList.length; i += 1) {
        (this.movePickerList[i] as marietta.webcad.control.parts.RoomMovePickerWall).disableDragger();
      }
    }

    showToolTips() {
      for (let i: number = 0; i < this.cornerPickerList.length; i += 1) {
        (this.cornerPickerList[i] as marietta.webcad.control.parts.RoomCornerDragger).enableDragger();
      }

      for (let i: number = 0; i < this.movePickerList.length; i += 1) {
        (this.movePickerList[i] as marietta.webcad.control.parts.RoomMovePickerWall).enableDragger();
      }
    }
}
